import { Icon, Input } from 'Components';
import { Select, Table, Tabs, Spin } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { PropertyData, SelectOption, UserData } from '../CampaignReport.type';
import UserDetailDrawer from './UserDetailDrawer';
import { useIsMobile } from 'Hooks';
import PaginationElement from 'PhishingManager/components/Pagination';
import { INDIVIDUAL_TABLE_COLUMNS, PROPERTY_TABLE_COLUMNS } from '../CampaignReport.constant';
import PropertyCard from './PropertyCard';
import { ColumnsType } from 'antd/es/table';
import IndividualListItem from './IndividualListItem';
import PropertyListItem from './PropertyListItem';
import DebounceInput from 'PhishingManager/components/DebouncedInput';


export const tempData: UserData[] = [
    {
        id: 1,
        name: "James Miller",
        email: "j.miller@grandplaza.com",
        propertyName: "Grand Plaza Hotel",
        groupName: "Front Desk",
        doneBy: "Human",
        result: "Passed",
        interaction: "Clicked"
    },
    {
        id: 2,
        name: "Sarah Jenkins",
        email: "s.jenkins@oceanview.com",
        propertyName: "Ocean View Resort",
        groupName: "Management",
        doneBy: "AI Automation",
        result: "Failed",
        interaction: "Submitted Data"
    },
    {
        id: 3,
        name: "Robert Chen",
        email: "r.chen@citysuites.com",
        propertyName: "City Center Suites",
        groupName: "Security",
        doneBy: "Human",
        result: "Passed",
        interaction: "Clicked"
    },
    {
        id: 4,
        name: "Linda Thompson",
        email: "l.thompson@grandplaza.com",
        propertyName: "Grand Plaza Hotel",
        groupName: "Housekeeping",
        doneBy: "AI Automation",
        result: "Failed",
        interaction: "Submitted Data"
    },
    {
        id: 5,
        name: "Michael Ross",
        email: "m.ross@budgetinn.com",
        propertyName: "Budget Inn",
        groupName: "Maintenance",
        doneBy: "Human",
        result: "Passed",
        interaction: "Clicked"
    },
    {
        id: 6,
        name: "Emily Blunt",
        email: "e.blunt@oceanview.com",
        propertyName: "Ocean View Resort",
        groupName: "Sales",
        doneBy: "AI Automation",
        result: "Passed",
        interaction: "Clicked"
    },
    {
        id: 7,
        name: "David Wright",
        email: "d.wright@citysuites.com",
        propertyName: "City Center Suites",
        groupName: "Finance",
        doneBy: "Human",
        result: "Failed",
        interaction: "Submitted Data"
    },
    {
        id: 8,
        name: "Jessica Alba",
        email: "j.alba@grandplaza.com",
        propertyName: "Grand Plaza Hotel",
        groupName: "HR",
        doneBy: "AI Automation",
        result: "Passed",
        interaction: "Clicked"
    },
    {
        id: 9,
        name: "Kevin Hart",
        email: "k.hart@budgetinn.com",
        propertyName: "Budget Inn",
        groupName: "Kitchen",
        doneBy: "Human",
        result: "Failed",
        interaction: "Submitted Data"
    },
    {
        id: 10,
        name: "Laura Palmer",
        email: "l.palmer@oceanview.com",
        propertyName: "Ocean View Resort",
        groupName: "Concierge",
        doneBy: "AI Automation",
        result: "Passed",
        interaction: "Clicked"
    }
];

export const hotelMockupData: PropertyData[] = [
    {
        key: "1",
        propertyName: "Grand Plaza Hotel",
        passRate: 98, // Trigger: Excellent (highest)
        openRate: 40,
        clickRate: 2,
        submissionRate: 0,
        emailsSent: 500,
        openedEmail: 200,
        clickedLink: 10,
        submittedData: 0,
        totalUsers: 500
    },
    {
        key: "2",
        propertyName: "Ocean View Resort",
        passRate: 95, // Trigger: Good (high)
        openRate: 60,
        clickRate: 5,
        submissionRate: 2,
        emailsSent: 300,
        openedEmail: 180,
        clickedLink: 15,
        submittedData: 6,
        totalUsers: 300
    },
    {
        key: "3",
        propertyName: "City Center Suites",
        passRate: 91, // Trigger: Fair (medium)
        openRate: 80,
        clickRate: 15,
        submissionRate: 8,
        emailsSent: 200,
        openedEmail: 160,
        clickedLink: 30,
        submittedData: 16,
        totalUsers: 200
    },
    {
        key: "4",
        propertyName: "Budget Inn",
        passRate: 85, // Trigger: Poor (low)
        openRate: 95,
        clickRate: 30,
        submissionRate: 25,
        emailsSent: 100,
        openedEmail: 95,
        clickedLink: 30,
        submittedData: 25,
        totalUsers: 100
    }
];

// Property Options
const propertyOptions: SelectOption[] = [
    { label: "All Properties", value: 0 },
    { label: "Central Business Hotel", value: 101 },
    { label: "Plaza Hotel", value: 102 },
    { label: "Ocean View Resort", value: 103 }
];

// Group Options
const groupOptions: SelectOption[] = [
    { label: "All Groups", value: 0 },
    { label: "Management", value: 201 },
    { label: "Front Desk", value: 202 },
    { label: "Housekeeping", value: 203 }
];

// Performed By Options
const performedByOptions: SelectOption[] = [
    { label: "All Personnel", value: 0 },
    { label: "System", value: 301 },
    { label: "Human", value: 302 }
];

// Result Options
const resultOptions: SelectOption[] = [
    { label: "All Results", value: 0 },
    { label: "Passed", value: 1 },
    { label: "Failed", value: 2 }
];

// Interaction Options
const interactionOptions: SelectOption[] = [
    { label: "All Interactions", value: 0 },
    { label: "Clicked Link", value: 402 },
    { label: "Submitted Data", value: 403 }
];

// Interaction Options
const DELIVERY_STATUS: SelectOption[] = [
    { label: "All delivery statuses", value: 0 },
    { label: "Delivered", value: 702 },
    { label: "Undelivered", value: 703 }
];

type TableDataType = UserData | PropertyData;
const initDeliveredState = {
    search: "",
    searchShow: "",
    property: 0,
    group: 0,
    doneBy: 0,
    result: 0,
    deliveryStatus: 0,
    interaction: 0
}

const PAGE_SIZE = 20;
const ReportList = ({ tab }: { tab: string }) => {
    const [individualState, setIndividualState] = useState({ ...initDeliveredState });
    const [tableState, setTableState] = useState({
        individualData: [],
        propertyData: [],
        currentPage: 1
    });
    const { currentPage } = tableState;
    const [isLoading, setIsLoading] = useState(false);
    const [selectedData, setSelectedData] = useState<UserData | null>(null);
    const isMobile = useIsMobile();
    const isIndividualTab = tab === "individual";
    const { search, searchShow, property, group, doneBy, interaction, result, deliveryStatus } = individualState;

    const tableColumn: ColumnsType<any> = isIndividualTab ? INDIVIDUAL_TABLE_COLUMNS : PROPERTY_TABLE_COLUMNS;
    const tableData: TableDataType[] = isIndividualTab ? (tempData as UserData[]) : (hotelMockupData as PropertyData[]);

    const handleState = (selectKey: string, value: any) => {
        setIndividualState(prev => ({ ...prev, [selectKey]: value }));
    }

    const debouncedSetSearch = useMemo(() => debounce((value: string) => handleState("search", value), 500), []);

    const fetchData = (part: string) => {
        if (isLoading) return;
        setIsLoading(true);
        console.log("logggged by ----->", part)
        setTimeout(() => setIsLoading(false), 2000);
    }

    useEffect(() => {
        fetchData("state");
    }, [search, property, group, doneBy, interaction, result, currentPage])

    useEffect(() => {
        fetchData("tab");
        if (tab === "property") setIndividualState({ ...initDeliveredState });
    }, [tab])

    useEffect(() => {
        return () => debouncedSetSearch.cancel();
    }, [debouncedSetSearch]);

    return <Spin spinning={isLoading}>
        <div className="report-section">
            <div className="table-header">
                <div className='description'>{isIndividualTab ? "Phishing test results: delivery, interactions, and outcomes" : "Performance metrics aggregated by property, including pass rate, engagement, and user activity across phishing simulations."}</div>
            </div>
            {isIndividualTab ? <div className={`campaign-filter-section`}>
                <DebounceInput placeholder="Search" setDebouncedSearch={(value) => handleState("search", value)} className="campaign-setup-search" />
                <SelectElement value={property} options={propertyOptions} onChange={(value) => handleState("property", value)} />
                <SelectElement value={property} options={groupOptions} onChange={(value) => handleState("group", value)} />
                <SelectElement value={result} options={resultOptions} onChange={(value) => handleState("result", value)} />
                <SelectElement value={doneBy} options={performedByOptions} onChange={(value) => handleState("doneBy", value)} />
                <SelectElement value={interaction} options={interactionOptions} onChange={(value) => handleState("interaction", value)} />
                <SelectElement value={deliveryStatus} options={DELIVERY_STATUS} onChange={(value) => handleState("deliveryStatus", value)} />
            </div> : <div className='cards-flex'>
                <PropertyCard title='48%' desc='Average Pass Rate' iconType='trendingArrow' />
                <PropertyCard title='Royal Sunset Hotel' desc='Best Performing' tagValue={91.89} />
                <PropertyCard title='3' desc='Below 90% Pass Rate' iconType='phishingManagerWarningModalPrefix' />
            </div>}

            {(!isMobile) ? <div className='table-section'>
                <Table
                    rowKey={(record) => record.key || record.id}
                    className="report-table"
                    dataSource={tableData}
                    columns={tableColumn}
                    pagination={false}
                    showSorterTooltip={false}
                    rowClassName={(_, index) =>
                        index % 2 === 0 ? "bg-white" : "bg-gray"
                    }
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: (event) => {
                                if (isIndividualTab) setSelectedData(record);
                            },
                        };
                    }}
                />
                <PaginationElement
                    total={tempData.length}
                    pageSize={PAGE_SIZE}
                    current={currentPage}
                    onChange={(page) => setTableState(prev => ({ ...prev, currentPage: page }))}
                />
            </div> : <div className='list-section'>
                {tableData.map((item, idx) => isIndividualTab ?
                    <IndividualListItem userData={item as UserData} key={idx} /> :
                    <PropertyListItem propertyData={item as PropertyData} key={idx} />)}
            </div>}
        </div>
        {!!selectedData && <UserDetailDrawer data={selectedData} visible={!!selectedData} onClose={() => setSelectedData(null)} />}
    </Spin>
}

export default ReportList;


const SelectElement = ({ value, options, onChange }: { value: number | string, options: { label: string, value: number | string }[], onChange: (value: any) => void }) => {
    return <Select
        className="campaign-setup-select"
        dropdownClassName="campaign-setup-filter-option-select"
        suffixIcon={<div className="cs-dropdownWrapper">
            <Icon type="campaignSetupDropdown" />
        </div>}
        value={value}
        onChange={onChange}
        options={options}
        getPopupContainer={(trigger) => trigger.parentElement}
    />
}